
  function openTab(evt, tabcontent) {
    var i, tabbtn, tabcon;
    tabbtn = document.getElementsByClassName("category-tab-btn");
    tabcon = document.getElementsByClassName("category-feature");

    for (i = 0; i < tabcon.length; i++) {
      tabcon[i].style.display = "none";
    }

    for (i = 0; i < tabbtn.length; i++) {
      tabbtn[i].className = tabbtn[i].className.replace(" active-tab", "");
    }

    document.getElementById(tabcontent).style.display = "flex";
    evt.target.className += " active-tab";
  }

  // function showSelectedProduct(productURL, productImage) {
  //   var selectedProductContainer = document.getElementById("selectedProduct");
  //   selectedProductContainer.innerHTML = `
  //     <div class="selected-product">
  //       <div class="thumbnail-c">
  //         <img class="img-thumb" src="${productImage}">
  //       </div>
  //       <p>Product Details</p>
  //       <!-- Add more details or customize as needed -->
  //     </div>
  //   `;
  // }

  document.getElementById("tab-cus-active").click();

